import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button, Input
} from "reactstrap";
// Modal, ModalHeader, ModalBody, ModalFooter
import MetaTags from "react-meta-tags";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import SweetAlert from "react-bootstrap-sweetalert";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import httprequester from "../../lib/httprequester";

class VerifikasiSTR extends Component {

  userData = null;

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      listVerifikasiSTR: [],
      alert: false,
      message: "",
      card_url: "",
      id: null,
      confirm_both: false,
      popupapprove: false,
      loading: false,
      card_status: {},
      popupreject: false,
      popupkartustr: false,
      str_no: '',
      str_name: '',
      str_id: 0,
      reason: '',
    };
    this.userData = JSON.parse(localStorage.getItem('user'));
  }

  componentDidMount() {
    this.getListVerifikasiSTR('W');
  }

  getListVerifikasiSTR = (status) => {
    let body = {
      card_status: status,
      page: 1,
      limit: 10,
    };
    httprequester.postnobody("admin/user_card_view_str", body, {
      success: async function (response) {
        let data = [];
        if (response.data.message == "success") {
          console.log("response", response.data.detailMessage)

          response.data.detailMessage.forEach(async (v, key) => {
            await data.push({
              str_no: v.str_no,
              user_name: v.user_name,
              user_email: v.user_email,
              str_name: v.str_name,
              str_id: v.str_id,
              card_status:
                v.card_status == "W"
                  ? "Waiting"
                  : v.card_status == "R"
                    ? "Reject"
                    : v.card_status == "A"
                      ? "Approve"
                      : "",
              created_at: v.created_at,
              card_url: v.card_url,
              card_id: v.card_id,
              user_id: v.user_id,
              // reason: "",
            });
          });
        }
        this.setState({
          listVerifikasiSTR: data,
        });
      }.bind(this),
      error: function (err) { }.bind(this),
    });
  };

  handleselect = e => {

    this.getListVerifikasiSTR(e.target.value);

  };


  popUpGenerateKartuSTR = row => {
    let check = this.state.listVerifikasiSTR.find(k => k.card_id == row);
    this.setState({
      popupkartustr: true,
      card_url: check.card_url,
    });
  };

  popUpGenerateReject = row => {
    let check = this.state.listVerifikasiSTR.find(k => k.card_id == row);
    this.setState({
      popupreject: true,
      card_status: check.card_status,
      card_id: row,
      str_name: check.str_name,
      str_id: check.str_id,
      str_no: check.str_no,
      user_id: check.user_id,
    });
  };

  popUpGenerateApprove = row => {
    let check = this.state.listVerifikasiSTR.find(k => k.card_id == row);
    this.setState({
      popupapprove: true,
      card_status: check.card_status,
      card_id: row,
      str_name: check.str_name,
      str_id: check.str_id,
      str_no: check.str_no,
      user_id: check.user_id,
    });
  };


  generateReject = () => {
    this.setState({
      popupreject: false,
      loading: true,
    });

    this.getListVerifikasiSTR('W');

    let { str_id, str_name, str_no, reason, user_id } = this.state;
    let body = {
      card_id: this.state.card_id,
      card_status: this.state.card_status == 'Approve' ? 'R' : this.state.card_status == 'Waiting' ? 'R' : '',
      str_id,
      str_name,
      str_no,
      reason,
      user_id,
      admin: this.userData?.admin_name
    };

    this.setState({
      reason: ''
    })

    console.log('isi2', body)



    httprequester.postnobody("admin/verification_status_user_str", body, {
      success: async function (response) {
        this.setState({
          message: response.data.detailMessage,
          loading: false,
          alert: true,
        });
      }.bind(this),
      error: function (err) { }.bind(this),
    });

  };

  closeApprove = () => {
    let select = document.querySelector('#mySelect');
    select.value = 'W'
    this.setState({
      alert: false,
    })
    this.getListVerifikasiSTR('W');
  }


  generateApprove = () => {
    this.setState({
      popupapprove: false,
      loading: true,
    });

    this.getListVerifikasiSTR('W');

    let { str_id, str_name, str_no, user_id } = this.state;
    let body = {
      card_id: this.state.card_id,
      card_status: this.state.card_status == 'Reject' ? 'A' : this.state.card_status == 'Waiting' ? 'A' : '',
      str_id,
      str_name,
      str_no,
      user_id,
      admin: this.userData?.admin_name
    };

    console.log('>>> accept this', body);

    httprequester.postnobody("admin/verification_status_user_str", body, {
      success: async function (response) {
        this.setState({
          message: response.data.detailMessage,
          loading: false,
          alert: true,
        });
      }.bind(this),
      error: function (err) { }.bind(this),
    });
    //
  };

  buttonverifikasi = (row) => {
    let status = this.state.listVerifikasiSTR.find(b => b.card_id == row);
    return (
      <div>
        <Button
          color="primary"
          className="btn-sm"
          onClick={e => {
            this.popUpGenerateKartuSTR(row);
          }}
        >
          Lihat Kartu STR
        </Button>
        &nbsp;
        {status.card_status == "Reject" ? (
          <Button
            color="success"
            className="btn-sm"
            onClick={e => {
              this.popUpGenerateApprove(row);
            }}
          >
            Approve
          </Button>
        ) : status.card_status == "Waiting" ? (
          <Button
            color="success"
            className="btn-sm"
            onClick={e => {
              this.popUpGenerateApprove(row);
            }}
          >
            Approve
          </Button>
        ) : (
          ""
        )}
        &nbsp;
        {status.card_status == "Approve" ? (
          <Button
            color="danger"
            className="btn-sm"
            onClick={e => {
              this.popUpGenerateReject(row);
            }}
          >
            Reject
          </Button>
        ) : status.card_status == "Waiting" ? (
          <Button
            color="danger"
            className="btn-sm"
            onClick={e => {
              this.popUpGenerateReject(row);
            }}
          >
            Reject
          </Button>
        ) : (
          ""
        )}
        &nbsp;
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "str_no",
        text: "Nomor STR",
        sort: true,
      },
      {
        dataField: 'user_name',
        text: "Nama User",
        sort: true,
      },
      {
        dataField: 'user_email',
        text: 'Email',
        sort: true
      },
      {
        dataField: "str_name",
        text: "Nama STR",
        sort: true,
      },
      {
        dataField: "card_status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "created_at",
        text: "Tanggal Registrasi",
        sort: true,
        formatter: row => {
          if (row !== "-") {
            return <div>{moment(row).format("YYYY-MM-DD HH:mm:ss")}</div>;
          }
          return <div>{row}</div>;
        },
      },
      {
        dataField: "card_id",
        text: "Action",
        sort: true,
        formatter: (row) => {
          return <div>{this.buttonverifikasi(row)}</div>;
        },
      },
    ];

    const defaultSorted = [
      {
        dataField: "created_at",
        order: "desc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.listVerifikasiSTR.length,
      custom: true,
    };

    const sizePerPageList = [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "15", value: 15 },
      { text: "20", value: 20 },
      { text: "25", value: 25 },
      { text: "All", value: this.state.listVerifikasiSTR.length },
    ];

    const { SearchBar } = Search;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Verifikasi STR | Ruang Ilmiah</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title="Halaman Utama"
              breadcrumbItem="Verifikasi STR"
            />
          </Container>
          <div className="container-fluid">
            {this.state.popupkartustr ? (
              <SweetAlert
                title="Kartu STR"
                onCancel={() => this.setState({ popupkartustr: false })}
                showCancel={true}
                showConfirm={false}
                style={{ width: "70em" }}
              >
                <form>
                  <img src={this.state.card_url} width={"100%"} />
                </form>
              </SweetAlert>
            ) : null}
            {this.state.popupapprove ?
              <SweetAlert
                title="Approve"
                onConfirm={() => this.generateApprove()}
                onCancel={() => this.setState({ popupapprove: false })}
                showCancel={true}
                showConfirm={true}
                type={'controlled'}
                dependencies={[this.state.str_name, this.state.str_no]}
              >
                {/* <p>{`Apakah Anda Yakin Akan Approve ?`}</p>
              </SweetAlert>
             : null */}
                {(renderProps) => (
                  <form>
                    <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'flex-start' }}>
                      <label style={{ fontWeight: 'bold' }}>
                        Nomor STR
                        <div style={{ width: '195%', display: 'flex', justifyContent: 'flex-start' }}>
                          <input
                            type={'text'}
                            ref={renderProps.setAutoFocusInputRef}
                            className="form-control"
                            value={this.state.str_no}
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            onChange={(e) => this.setState({ str_no: e.target.value })}
                            placeholder={'Nomor STR'}
                          />
                        </div>
                      </label>
                    </div>
                    <br />
                    <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'flex-start' }}>
                      <label style={{ fontWeight: 'bold' }}>
                        Nama STR
                        <div style={{ width: '195%', display: 'flex', justifyContent: 'flex-start' }}>
                          <input
                            type={'text'}
                            className="form-control"
                            value={this.state.str_name}
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            onChange={(e) => this.setState({ str_name: e.target.value })}
                            placeholder={'Nama STR'}
                          />
                        </div>
                      </label>
                    </div>
                  </form>
                )}
              </SweetAlert> : null
            }

            {this.state.popupreject ?
              <SweetAlert
                title="Reject"
                onConfirm={() => this.generateReject()}
                onCancel={() => this.setState({ popupreject: false, reason: '' })}
                showCancel={true}
                showConfirm={true}
                type={'controlled'}
                dependencies={[this.state.str_name, this.state.str_no]}
              >
                {/* <p>{`Apakah Anda Yakin Akan Reject ?`}</p>
              </SweetAlert>
            ) : null */}
                {(renderProps) => (
                  <form>
                    <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'flex-start' }}>
                      <label style={{ fontWeight: 'bold' }}>
                        Nomor STR
                        <div style={{ width: '195%', display: 'flex', justifyContent: 'flex-start' }}>
                          <input
                            disabled
                            type={'text'}
                            ref={renderProps.setAutoFocusInputRef}
                            className="form-control"
                            value={this.state.str_no}
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            onChange={(e) => this.setState({ str_no: e.target.value })}
                            placeholder={'Nomor STR'}
                          />
                        </div>
                      </label>
                    </div>

                    <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'flex-start' }}>
                      <label style={{ fontWeight: 'bold' }}>
                        Nama STR
                        <div style={{ width: '195%', display: 'flex', justifyContent: 'flex-start' }}>
                          <input
                            disabled
                            type={'text'}
                            className="form-control"
                            value={this.state.str_name}
                            onKeyDown={renderProps.onEnterKeyDownConfirm}
                            onChange={(e) => this.setState({ str_name: e.target.value })}
                            placeholder={'Nama STR'}
                          />
                        </div>
                      </label>
                    </div>
                    <br />
                    <div className="mb-3" style={{ textAlign: 'left' }}>
                      <label style={{ fontWeight: 'bold' }}>Reason Reject</label>
                      <Input
                        type="textarea"
                        style={{ width: '96%', display: 'flex', justifyContent: 'flex-start' }}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({
                            reason: e.target.value
                          })
                        }}
                        value={this.state.reason}
                        onKeyDown={renderProps.onEnterKeyDownConfirm}
                      />
                    </div>
                  </form>
                )}
              </SweetAlert> : null
            }
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="card_id"
                      columns={columns}
                      data={this.state.listVerifikasiSTR}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="card_id"
                          columns={columns}
                          data={this.state.listVerifikasiSTR}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col md="4">
                                  <Input
                                    onChange={this.handleselect}
                                    type="select"
                                    id="mySelect"
                                  >
                                    <option value="W">Waiting</option>
                                    <option value="A">Approve</option>
                                    <option value="R">Reject</option>
                                  </Input>
                                  <br />
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"card_id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <br />
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          {this.state.alert ?
            <SweetAlert title={this.state.message} onConfirm={this.closeApprove}>
            </SweetAlert> : ''
          }
        </div>
      </React.Fragment>
    );
  }
}
export default VerifikasiSTR;
